import { ReadProjectStore, WriteProjectStore } from "@/types/projectStore";
import { APIService } from "../../../services/api";
import { API } from "@/lib/api";

export const ProjectStoreService = new APIService<
  ReadProjectStore,
  WriteProjectStore
>(API.Projects);
